import { componentsOptions, liveComponentsOptions } from "@/utils/dashboardUtils";
import PropTypes from "prop-types";
import React from "react";
import { Card, Col, Modal, Row } from "react-bootstrap";
import { v4 as uuidV4 } from "uuid";

function DashboardComponentModal({ show, setShow, editItem, setEditItem, setAddItemModal, gridData, iframe, type }) {
  const handleClose = () => {
    setShow(false);
    setEditItem({});
  };

  const handleClick = (component) => {
    const extraDefaults =
      component === "alarmNotification"
        ? {
            chartTitle: "<p>Alarm Notification</p>",
            notificationTypes: ["offlineDevice", "alarm"],
            notificationLimit: 5,
          }
        : {};
    setEditItem((pre) => ({
      _id: pre?._id || uuidV4(),
      ...extraDefaults,
      ...pre,
      component,
    }));
    setShow(false);
    setAddItemModal(true);
  };

  const components = (type === "live" ? liveComponentsOptions : componentsOptions) || [];

  return (
    <>
      <Modal show={show} onHide={handleClose} centered size="lg">
        {/* body */}
        <Modal.Body className="p-4">
          <Row md={2} xs={1} className="g-3">
            {components.map((component, ind) => (
              <Col key={ind}>
                <button className="btn w-100" disabled={(component.value === "iframe" && gridData.length) || iframe}>
                  <Card
                    className={`p-3 rounded-3 w-100 ${
                      editItem.component === component.value && "border-primary bg-primary-subtle"
                    }`}
                    style={{ cursor: "pointer" }}
                    onClick={() => handleClick(component.value)}
                  >
                    <div className="d-flex">
                      <div style={{ fontSize: 24, width: 35 }}>{component.icon}</div>
                      <div className="pl-3">
                        <Card.Title className="mb-1 text-start">{component.label}</Card.Title>
                        <Card.Text className="text-muted">{component.subtitle}</Card.Text>
                      </div>
                    </div>
                  </Card>
                </button>
              </Col>
            ))}
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default DashboardComponentModal;

DashboardComponentModal.propTypes = {
  show: PropTypes.bool,
  setShow: PropTypes.func,
  mode: PropTypes.string,
  editItem: PropTypes.object,
  setEditItem: PropTypes.func,
  gridData: PropTypes.array,
  setGridData: PropTypes.func,
  iframe: PropTypes.string,
  setAddItemModal: PropTypes.func,
  type: PropTypes.string,
};
